export enum OrderColumn {
    ASC = "asc",
    DESC = "desc",
}
